import { DatePipe } from '@angular/common';
import { Component, OnInit, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as $ from 'jquery';
import * as _ from 'lodash';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { enGbLocale } from 'ngx-bootstrap/locale';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../shared/config/app-config';
import { PatientService, User, UserService } from '../../shared';
import { TranslateService } from '@ngx-translate/core';

@Component({
	templateUrl: 'myprofile.component.html',
	styleUrls: ['./style.component.css']
})

export class MyprofileComponent implements OnInit {
	temcode: any = ''
	temMail: any;
	temPhone: any;
	temPhoneOther: any;
	emailvaild: boolean = false;
	passval: boolean = false;
	passval1: boolean = false;
	passval2: boolean = false;
	passval3: boolean = false;
	passval4: boolean = false;
	passkey: boolean = false;
	passkey1: boolean = false;
	passkey2: boolean = false;
	passkey3: boolean = false;
	passkey4: boolean = false;
	passlast: boolean = false;
	passlast1: boolean = false;
	passlast2: boolean = false;
	passlast3: boolean = false;
	passlast4: boolean = false;
	emailstatus: boolean = false;
	datapresent: boolean = false;
	showloader: boolean = false;
	required: boolean = false;
	maxdate: boolean;
	mindate: boolean;
	showinvaild1: boolean;
	spantrue: any;
	dataimg: any;
	email: any;
	maxlen: any;
	maxlen1: any
	setmask: any;
	setmask1: any;
	setlength: any;
	setlength1: any;
	alterNo: any;
	question: any;
	imagearr: any;
	public imgMaxSize = environment.imagefileSize
	public data: Object;
	public respass = '';
	res: string = '';
	CurrentUser: User;
	public timealert = environment.timelimit;
	Pswf: any
	homedata: any;
	codes: any = [];
	prefLang: any;

	// myInputVariable: any;
	public patientUrl = './assets/img/users/addusericon.png'
	public defaultUl = './assets/img/users/addusericon.png'
	public dateformat = environment.dateFormat;
	public bsConfig = Object.assign({}, { containerClass: 'theme-dark-blue', showWeekNumbers: false, dateInputFormat: this.dateformat });
	maxDate = new Date();
	hospitalid: any;
	patientid: any;
	cid: any;
	ScreenUpdatePrefLang: boolean = true;		//only for patient
	public selectques = [];
	public selectques1 = [];
	public selectques2 = [];
	secQuestionOne: any = '';
	secQuestionThree: any = '';
	secQuestionTwo: any = '';
	secQusAnswerOne: any
	secQusAnswerThree: any
	secQusAnswerTwo: any
	checkabout: any
	resp: any = '';
	resab: any;
	resabs: any;
	resepon: any;
	public myobj: any = {};
	public cha: any = {};
	public phone: any = ''
	public comType: any = ""
	public Patpro: any = {
		bpci: 'No',
		PatientSWfId: '',
		code: '+1,USA',
		comType: ' '
	};
	public bobMaxDate = new Date();
	public datenew = new Date("01/01/1800");
	apiurl: any = environment.api_url;
	modalRef: BsModalRef;
	modalRef1: BsModalRef;
	languageConfig = {
		"multiLanguageRequired" : false,
		"languages": []
	}

	constructor(
		public datepipe: DatePipe,
		private router: Router,
		private route: ActivatedRoute,
		private userService: UserService,
		private patientservice: PatientService,
		private modalService: BsModalService,
		private toast: ToastrService,
		private localeService: BsLocaleService,
		private translate: TranslateService
	) {
		this.translate.setDefaultLang(userService.defaultLang);
		enGbLocale.invalidDate = '';
		enGbLocale.weekdaysShort = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
		enGbLocale.week.dow = 0;
		defineLocale('custom locale', enGbLocale);
		this.localeService.use('custom locale');
		this.prefLang = this.userService.defaultLang;
	}
	changepassword: boolean = false;
	imageURL: string = environment.cloudeImageURL;
	ngOnInit() {

		this.userService.currentUser.subscribe(
			(userData) => {
				this.CurrentUser = userData;
				if (this.CurrentUser.item) {
					this.setmask = this.CurrentUser.item.phoneFormat.split('#').join('0').concat('0');
					this.setmask1 = this.CurrentUser.item.phoneFormat.split('#').join('0').concat('0');
					if (this.CurrentUser.item.dateFormat.toLowerCase() == 'mmddyyyy') {
						this.dateformat = environment.dateFormat;
					}
					else if (this.CurrentUser.item.dateFormat.toLowerCase() == 'ddmmyyyy') {
						this.dateformat = 'DD/MM/YYYY'
					}
					this.bsConfig = Object.assign({}, { containerClass: 'theme-dark-blue', showWeekNumbers: false, dateInputFormat: this.dateformat });
				}
			}
		)

		if (this.CurrentUser.item.hostModel == "CLOUD")
			this.imageURL = environment.cloudeImageURL;
		else
			this.imageURL = environment.vmImageURL;


		this.hospitalid = this.CurrentUser.item.userAccountKey;
		////console.log("id",this.hospitalid)
		this.userService.PUser.subscribe(
			(user) => {
				this.Pswf = user;

			}
		)
		if (window.localStorage['ccdetails']) {
			let ccdetails = JSON.parse(atob(window.localStorage['ccdetails']))
			this.cid = ccdetails.cnuseraccid;
			this.ScreenUpdatePrefLang = false
		} else {
			this.cid = this.CurrentUser.item.userAccountId;
			this.ScreenUpdatePrefLang = true
		}
		if (this.route.snapshot.url[0].path != 'assessment') {
			this.CurrentUser.operationStatus = ''
		}
		if (window.localStorage['ccdetails']) {
			this.changepassword = false;
		}
		else {
			this.changepassword = true;
		}
		this.userService
			.getPatprofile()
			.subscribe(
				data => {
					for (var i = 0; i < data.length; i++) {
						this.Patpro = data[i];
						this.temMail = data[i].email;
						this.temPhone = data[i].phone;
						this.temcode = data[i].teleCode;
						this.temPhoneOther = data[i].phoneOther;
						this.email = data[i].email;
						this.phone = data[i].phone ? data[i].phone : "";
						this.prefLang = this.Patpro?.preferredLanguage;
						this.getPreferredLanguage(this.email);
						if (this.Patpro.Imagepath.search("default_") == -1)
							this.dataimg = this.imageURL + this.Patpro.Imagepath;
						else
							this.dataimg = this.defaultUl
						if (this.Patpro.phone) {
							this.Patpro.code = this.Patpro.teleCode + ',' + this.Patpro.teleCountryCode
						}
						else {
							if (this.CurrentUser.item.language != 'en_uk') {
								this.Patpro.code = '+1,USA'
							} else if (this.CurrentUser.item.language == 'en_uk') {
								this.Patpro.code = '+44,UK'
							}
							if (this.CurrentUser.item.clientTeleCode)
								this.Patpro.code = this.CurrentUser.item.clientTeleCode + ',' + this.CurrentUser.item.clientCountryCode

						}
						if (this.Patpro.phoneOther) {
							this.phoneOthervalue = true
							this.Patpro.codeOther = this.Patpro.teleCodeOther + ',' + this.Patpro.teleCountryCodeOther
						}
						else {
							if (this.CurrentUser.item.language != 'en_uk') {
								this.Patpro.codeOther = '+1,USA'
							} else if (this.CurrentUser.item.language == 'en_uk') {
								this.Patpro.codeOther = '+44,UK'
							}
							if (this.CurrentUser.item.clientTeleCode)
								this.Patpro.codeOther = this.CurrentUser.item.clientTeleCode + ',' + this.CurrentUser.item.clientCountryCode

						}
						this.Patpro.otherPhoneType = data[i].otherPhoneType ? data[i].otherPhoneType : 1
						this.tempCode = this.Patpro.code
						this.checkphonelength(this.Patpro.code, false);
						this.checkphonlength(this.Patpro.code);
						this.checkphonelength1(this.Patpro.codeOther, false);
						this.checkphonlength1(this.Patpro.codeOther);
						if (this.Patpro.comType)
							this.Patpro.comType = this.Patpro.comType.toUpperCase()
						else
							this.Patpro.comType = "NONE"
						if (!self.Patpro.comType) {
							if (self.Patpro.email && self.Patpro.phone) {
								self.Patpro.comType = "BOTH"
								self.required = true
							}
							else if (!self.Patpro.email) {
								self.Patpro.comType = "TEXT"
								self.required = false
							}
							else if (!self.Patpro.phone) {
								self.Patpro.comType = "EMAIL"
								self.required = true
							} else {
								self.Patpro.comType = "NONE"
							}
						}
						//////console.log(this.Patpro);
						else if (self.Patpro.comType == "NONE") {
							this.comType = "NONE"
							self.Patpro.comType = "NONE"
						}
					}

					if (this.Patpro.phone || this.Patpro.email) {
						this.datapresent = true;
					}
					if (!this.Patpro.phone && !this.Patpro.email) {
						this.Patpro.comType = "NONE"
					}
				}
			);
		this.userService
			.getAboutme()
			.subscribe(
				data => {
					this.homedata = data.profileQuestions;
					for (var l = 0; l < this.homedata.length; l++) {
						if (this.homedata[l].answer) {
							this.spantrue = true
						}
					}
					// //////console.log(this.homedata);
				}

			);

		let self = this;
		self.patientservice.getselcode(this.hospitalid)
			.subscribe(data => {
				self.codes = data
				////console.log("code",data)
			})
		self.patientservice.getAlterNo()
			.subscribe(data => {
				self.alterNo = data
				self.Patpro.otherPhoneType = 1
			})

		this.Patpro.otherPhoneType = 1;

		this.getSecurityQuestions();
	}

	getSecurityQuestions() {
		// Security Questions
		this.patientservice
			.getquestions()
			.subscribe(
				data => {
					////console.log(data);
					if (data) {

						this.question = data;
						this.resabs = '';
						this.getSecretQue();
					}
					else {
					}
				}
			);

			this.userService
			.getAboutme()
			.subscribe(
				data => {
					this.homedata = data.profileQuestions;
					for (var l = 0; l < this.homedata.length; l++) {
						if (this.homedata[l].answer) {
							this.spantrue = true
						}
					}
					// //////console.log(this.homedata);
				}
			);
	}
	
	getPreferredLanguage(email) {
		const credential = {
			'userName': !email && !this.temPhone ? null : !email ? this.Patpro.teleCode.replace("+",'') + "-" + this.temPhone : email
		}
		if(!email && !this.temPhone)
			credential['clientId'] = this.CurrentUser?.item?.userAccountKey || '';
		
		this.userService.getLanguageConfig(credential).subscribe(
		langConfigRes => {
			if(langConfigRes && langConfigRes.hasOwnProperty("multiLanguageRequired")) {
			this.languageConfig = langConfigRes;
			if(langConfigRes?.multiLanguageRequired) {
				this.prefLang = langConfigRes?.preferredlanguage || this.Patpro?.preferredLanguage;
				setTimeout(() => {
					const cnDropElement = document.getElementById("multilang") as HTMLSelectElement;
					if (cnDropElement) {
						cnDropElement.value = langConfigRes?.preferredlanguage || this.Patpro?.preferredLanguage;
					}
				}, 500);
			}
			}
		});
	}

	checkempty1(id) {
		let date
		if (id != 'Invalid Date')
			date = this.datepipe.transform(id, 'yyyy-MM-dd');
		let curentdate = this.datepipe.transform(new Date(), 'yyyy-MM-dd');
		if (id == '' || id == null || id == 'Invalid Date') {
			this.showinvaild1 = true;
			this.mindate = false;
			this.maxdate = false;
		} else if (id != '' && id != null && date <= "1800-01-01") {
			this.mindate = true;
			this.showinvaild1 = false;
			this.maxdate = false;
		} else if (id != '' && id != null && date > curentdate) {
			this.maxdate = true;
			this.showinvaild1 = false;
			this.mindate = false;
		} else {
			this.showinvaild1 = false;
			this.mindate = false;
			this.maxdate = false;
		}

	}



	fileUpload(event) {
		let acceptFormat = ['image/png', 'image/x-png', 'image/jpeg', 'image/jpg']
		let reader = new FileReader();
		reader.readAsDataURL(event.target.files[0]);
		reader.onload = (events: any) => {
			if (!acceptFormat.includes(event.target.files[0].type)) {
				this.toast.error(this.userService.translateText('patient_portal.validations.file_not_allowed.error_label'), '', {
					timeOut: this.timealert
				})
				// this.myInputVariable.nativeElement.value = "";
				this.dataimg = this.defaultUl;
				return;
			}
			////console.log("size",event.target.files[0].size)
			////console.log("size1	",this.imgMaxSize)
			if (event.target.files[0].size > this.imgMaxSize) {

				this.toast.error(this.userService.translateText('patient_portal.validations.maximum_size_exceed.error_label'), '', {
					timeOut: this.timealert
				})
				// this.myInputVariable.nativeElement.value = "";
				this.dataimg = this.defaultUl;
				return;
			} else {
				this.dataimg = events.currentTarget.result;
				this.imagearr = [{
					filename: event.target.files[0].name,
					filetype: event.target.files[0].type,
					value: events.currentTarget.result.split(',')[1]
				}];
			}

		}
	}
	getBpci(dob) {
		let diff_ms = Date.now() - dob.getTime();
		let age_dt = new Date(diff_ms);

		let age = Math.abs(age_dt.getUTCFullYear() - 1970);
		if (age >= 65) {
			return 'Yes';
		}
		if (age < 65) {
			return 'No'
		}
	}

	checkPwd(pas) {
		if (pas.target.value) {
			this.patientservice.chkPass(pas.target.value)
				.subscribe(
					data => {
						if (data[0].status == 'failure') {
							this.cha.newPassword = '';
							this.cha.confirmPassword = '';
							this.toast.error(data[0].message)
						}
					})
		}
	}

	validateEmail(email) {

		var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(String(email).toLowerCase());

	}
	validatemail: any = false
	checkEmail(userdetails) {
		let self = this;
		let checkEmail = self.validateEmail(self.Patpro.email.toLowerCase())
		if (checkEmail && self.temMail != self.Patpro.email) {
			self.validatemail = false
			let data = {
				"oldEmail": self.temMail ? self.temMail : '',
				"newEmail": self.Patpro.email,
				"oldPhone": '',
				"newPhone": '',
				"addOrEdit": "edit",
				"updatingProfileRole": self.CurrentUser.item.userGroupId
			}
			self.patientservice.getUserExist(data, this.CurrentUser.item.userAccountKey)
				.subscribe(data => {
					if (data.status == 'success') {
						if (data.popUpStatus) {
							self.required = true
							this.userService.getuserdetails(self.Patpro.email.toLowerCase())
								.subscribe(
									data => {
										if (data.firstName) {
											this.userinfo = data
											if (((!this.Patpro.firstName && !this.Patpro.lastName && !this.Patpro.email) || (data.firstName != this.Patpro.firstName) || (data.lastName != this.Patpro.lastName))) {
												// if (self.Patpro.phone) {
												// 	self.Patpro.comType = "TEXT"
												// 	self.required = false
												// }
												// else{
												self.Patpro.comType = "NONE"
												//}

												this.modalRef1 = this.modalService.show(userdetails, {
													class: 'modal-md',
													backdrop: 'static'
												})
												this.movable();
											}
										}
									})
						}

					} else {
						self.Patpro.email = ""
						if (self.Patpro.phone) {
							self.Patpro.comType = "TEXT"
							self.required = false
						}
						else {
							self.Patpro.comType = "NONE"
						}
						this.toast.error(this.userService.translateText('patient_portal.validations.email_already_exist.error_label'), '', {
							timeOut: this.timealert
						})
					}
				})
		} else if (!checkEmail && self.Patpro.email) {
			self.Patpro.email = ""
			self.required = true;
			self.validatemail = true
			self.toast.error(this.userService.translateText('patient_portal.validations.enter_a_valid_email.error_label'), '', {
				timeOut: this.timealert
			})

		}
		if (!self.Patpro.email && !self.Patpro.phone && self.temMail != self.Patpro.email) {
			self.Patpro.comType = "NONE"
			self.required = true
		}
		else if (self.Patpro.email && !self.Patpro.phone && self.temMail != self.Patpro.email) {
			self.Patpro.comType = "EMAIL"
			self.required = true
		}
		else if (self.Patpro.email && self.Patpro.phone && self.temMail != self.Patpro.email) {
			self.Patpro.comType = "BOTH"
			self.required = true
		}
		else if (!self.Patpro.email && self.Patpro.phone && self.temMail != self.Patpro.email) {
			self.Patpro.comType = "TEXT"
			self.required = false
		}
		else if (self.temMail != self.Patpro.email) {
			self.Patpro.comType = "NONE"
		}
	}
	validateCompType() {
		let self = this;
		if (self.temMail == self.Patpro.email) {
			if (self.Patpro.email && self.Patpro.phone) {
				self.Patpro.comType = "BOTH"
				self.required = true
			}
			else if (self.Patpro.email) {
				self.Patpro.comType = "EMAIL"
				self.required = true
			}
			return;
		}
	}




	openModal(template: TemplateRef<any>) {
		this.modalRef = this.modalService.show(template, { class: 'modal-sm', backdrop: 'static' });
	}
	getvalue(eventtype, event) {
		////console.log("value",event)
		if (eventtype.target.checked && ((event == 'EMAIL' && this.Patpro.comType == 'TEXT') || (event == 'TEXT' && this.Patpro.comType == 'EMAIL'))) {
			this.Patpro.comType = 'BOTH'
		} else if (eventtype.target.checked && event == 'EMAIL') {
			this.Patpro.comType = 'EMAIL'
		} else if (eventtype.target.checked && event == 'TEXT') {
			this.Patpro.comType = 'TEXT'
		} else if (!eventtype.target.checked && event == 'EMAIL' && this.Patpro.comType == 'BOTH') {
			this.Patpro.comType = 'TEXT'
		} else if (!eventtype.target.checked && event == 'TEXT' && this.Patpro.comType == 'BOTH') {
			this.Patpro.comType = 'EMAIL'
		} else {
			this.Patpro.comType = "NONE"
		}
	}
	savepro(p, temppassword, logout) {
		if (this.temMail == this.Patpro.email) {
			// this.saveprofile(p,temppassword,logout)
			if (this.temPhone == this.Patpro.phone) {
				this.saveprofile(p, temppassword, logout)
			} else {
				let code = this.Patpro.code.split(',')
				let phone = code[0] + '-' + this.Patpro.phone
				this.checkPatientPhoneExists(phone, this.CurrentUser.item.userAccountKey, p, temppassword, logout)
			}
		} else {
			if (p.value.email) {
				this.patientservice.getPatientEmailExist(p.value.email.toLowerCase(), this.CurrentUser.item.userAccountKey)
					.subscribe(data => {
						////console.log(this.timealert)
						if (!data) {
							// this.saveprofile(p,temppassword,logout)
							if (this.temPhone == this.Patpro.phone) {
								this.saveprofile(p, temppassword, logout)
							} else {
								let code = this.Patpro.code.split(',')
								let phone = code[0] + '-' + this.Patpro.phone
								this.checkPatientPhoneExists(phone, this.CurrentUser.item.userAccountKey, p, temppassword, logout)
							}
						}

					})
			} else
				this.saveprofile(p, temppassword, logout)
		}
	}
	checkPatientPhoneExists(phone, userAccountKey, p, temppassword, logout) {
		this.patientservice.chenckPatientPhoneExists(phone, userAccountKey)
			.subscribe(data => {
				if (!data) {
					this.saveprofile(p, temppassword, logout)
				}
			})
	}
	tempCode: any;
	saveprofile(p, temppassword, logout) {
		this.resp = " ";
		if(!p.value.phone && !p.value.email) {
			this.toast.error(this.userService.translateText('patient_portal.display_messages.mobole_email_valdation.error'), '', {
				timeOut: this.timealert
			})
			return;
		}
		this.showloader = true;
		if (this.Pswf.PayorType == 2) {
			p.value.bpci = 'Yes'
			// p.value.bpci = this.getBpci(p.value.dob)
		}
		else {
			p.value.bpci = 'No'
		}
		p.value.PatientSWfId = window.localStorage['Puser']
		p.value.comType = this.Patpro.comType
		if (!p.value.comType) {
			p.value.comType = "NONE"
		}

		p.value.uploadimage = this.imagearr;
		if (this.imagearr == undefined) {
			p.value.uploadimage = [];
		}
		if (!p.value.phone) {
			p.value.phone = "";
		}
		if (p.value.phone) {
			let telecode = p.value.code.split(',')
			p.value.teleCode = telecode[0]
			p.value.teleCountryCode = telecode[1]
		} else {
			p.value.teleCode = ''
			p.value.teleCountryCode = ''
		}
		if (!p.value.phoneOther) {
			p.value.phoneOther = "";
		}
		if (!p.value.otherPhoneType) {
			p.value.otherPhoneType = "";
		}
		if (p.value.phoneOther) {
			let telecode = p.value.codeOther.split(',')
			p.value.teleCodeOther = telecode[0]
			p.value.teleCountryCodeOther = telecode[1]
		} else {
			p.value.teleCodeOther = ''
			p.value.teleCountryCodeOther = ''
		}
		if (p.value.uploadimage.length > 0) {
			if (p.value.uploadimage[0].value) {
				this.imgprofile('isImageUploadDone');
			}
		}
		p.value.dob = this.datepipe.transform(this.changeFormatToDate(p.value.dob), 'yyyy-MM-dd');
		p.value.loggedInUserAccountId = this.CurrentUser.item.userAccountId
		//////console.log(p.value);
		this.userService.updpat(p.value)
			.subscribe(
				data => {
					this.showloader = false;

					if (data.updateStatus == "true") {
						if(this.prefLang !== this.userService.defaultLang && this.ScreenUpdatePrefLang) {
							this.userService.setCurrentLanguage(this.prefLang);
							setTimeout(() => this.getSecurityQuestions(), 500);							
						}
						this.patientservice.getAlterNo()
						.subscribe(data => {
							this.alterNo = data;
						})
						setTimeout(() => {		//Added for 
							if (p.value.email != this.email) {
								if (p.value.email != '')
									this.respass = this.userService.translateText('patient_portal.display_messages.update_your_mail_address') + this.userService.translateText('patient_portal.display_messages.use_the_email_address');
								else
									if (this.CurrentUser.item.helpDeskNo && !p.value.phone && this.CurrentUser.item.helpDeskNo.search('support') == -1) {
										this.respass = this.userService.translateText('patient_portal.display_messages.removed_your_email_address')+this.userService.translateText('patient_portal.display_messages.please_email_or_call') + this.CurrentUser.item.helpDeskNo + this.userService.translateText('patient_portal.display_messages.activate_account');
									} else if ((!this.CurrentUser.item.helpDeskNo || this.CurrentUser.item.helpDeskNo.search('support') != -1) && !p.value.phone) {
										this.respass = this.userService.translateText('patient_portal.display_messages.account_deactivated')+this.userService.translateText('patient_portal.display_messages.deactivated_account');
									} else {
										this.respass = this.userService.translateText('patient_portal.display_messages.phone_no_as_username') + this.userService.translateText('patient_portal.display_messages.phone_number_as_username');
									}
								this.modalRef = this.modalService.show(logout, {
									class: 'fit-width',
									backdrop: true,
									ignoreBackdropClick: true,
									keyboard: false
								});
	
							}
							else if (p.value.phone != this.phone && this.phone != null) {
								if (p.value.phone != '')
									this.respass = this.userService.translateText('patient_portal.display_messages.phone_number_has_updated') + this.userService.translateText('patient_portal.display_messages.phone_number_as_username');
								else
									if (this.CurrentUser.item.helpDeskNo && !p.value.email && this.CurrentUser.item.helpDeskNo.search('support') == -1) {
										this.respass = this.userService.translateText('patient_portal.display_messages.phone_no_removed.success')+this.userService.translateText('patient_portal.display_messages.please_email_or_call') + this.CurrentUser.item.helpDeskNo + this.userService.translateText('patient_portal.display_messages.activate_account');
									} else if ((!this.CurrentUser.item.helpDeskNo || this.CurrentUser.item.helpDeskNo.search('support') != -1) && !p.value.email) {
										this.respass = this.userService.translateText('patient_portal.display_messages.phone_no_removed.success') + this.userService.translateText('patient_portal.display_messages.deactivated_account');
									} else {
										this.respass =  this.userService.translateText('patient_portal.display_messages.number_removed.success') +  this.userService.translateText('patient_portal.display_messages.use_the_email_address');
									}
								this.modalRef = this.modalService.show(logout, {
									class: 'fit-width',
									backdrop: true,
									ignoreBackdropClick: true,
									keyboard: false
								});
	
							}
							else {
								this.respass = this.userService.translateText('patient_portal.display_messages.profile_updated.success');
								this.userService.logAudit("updateProfile", 0).subscribe(data => { })
								this.modalRef = this.modalService.show(temppassword, {
									class: 'modal-sm', backdrop: true,
									ignoreBackdropClick: true,
									keyboard: false
								});
								this.userService.populate();
								let self = this;
								this.userService.getPatprofile().subscribe(
									data => {
										for (var i = 0; i < data.length; i++) {
											this.Patpro = data[i];
											this.temMail = data[i].email;
											this.temPhone = data[i].phone;
											this.temcode = data[i].teleCode;
											this.temPhoneOther = data[i].phoneOther;
											this.email = data[i].email;
											this.phone = data[i].phone;
											this.Patpro.otherPhoneType = data[i].otherPhoneType ? data[i].otherPhoneType : 1
											if (this.Patpro.Imagepath.search("default_") == -1)
												this.dataimg = this.imageURL + this.Patpro.Imagepath;
											else
												this.dataimg = this.defaultUl
											if (this.Patpro.phone) {
												this.Patpro.code = this.Patpro.teleCode + ',' + this.Patpro.teleCountryCode
											}
											else {
												if (this.CurrentUser.item.language != 'en_uk') {
													this.Patpro.code = '+1,USA'
												} else if (this.CurrentUser.item.language == 'en_uk') {
													this.Patpro.code = '+44,UK'
												}
												if (this.CurrentUser.item.clientTeleCode)
													this.Patpro.code = this.CurrentUser.item.clientTeleCode + ',' + this.CurrentUser.item.clientCountryCode
	
											}
											this.tempCode = this.Patpro.code
											if (this.Patpro.phoneOther) {
												this.phoneOthervalue = true
												this.Patpro.codeOther = this.Patpro.teleCodeOther + ',' + this.Patpro.teleCountryCodeOther
											}
											else {
												this.phoneOthervalue = false
												if (this.CurrentUser.item.language != 'en_uk') {
													this.Patpro.codeOther = '+1,USA'
												} else if (this.CurrentUser.item.language == 'en_uk') {
													this.Patpro.codeOther = '+44,UK'
												}
												if (this.CurrentUser.item.clientTeleCode)
													this.Patpro.codeOther = this.CurrentUser.item.clientTeleCode + ',' + this.CurrentUser.item.clientCountryCode
	
											}
											if (this.Patpro.comType)
												this.Patpro.comType = this.Patpro.comType.toUpperCase()
											else
												this.Patpro.comType = "NONE"
											if (!self.Patpro.comType) {
												if (self.Patpro.email && self.Patpro.phone) {
													self.Patpro.comType = "BOTH"
													self.required = true
												}
												else if (!self.Patpro.email) {
													self.Patpro.comType = "TEXT"
													self.required = false
												}
												else if (!self.Patpro.phone) {
													self.Patpro.comType = "EMAIL"
													self.required = true
												} else {
													self.Patpro.comType = "NONE"
												}
											}
											//////console.log(this.Patpro);
											else if (self.Patpro.comType == "NONE") {
												this.comType = "NONE"
												self.Patpro.comType = "NONE"
											}
										}
	
										if (this.Patpro.phone || this.Patpro.email) {
											this.datapresent = true;
										}
										if (!this.Patpro.phone && !this.Patpro.email) {
											this.Patpro.comType = "NONE"
										}
									}
								);
							}
						}, 450);
					}
					else if (data.updateStatus == "Email address already exists") {

						this.resp = this.userService.translateText('patient_portal.display_messages.email_already_exists.error');
					}
					else if (data.updateStatus == "false") {
						this.resp = this.userService.translateText('patient_portal.display_messages.enter_all_fields.error');
					}
					else {
						// this.resp = "Enter all the fields ";
						this.respass = this.userService.translateText('patient_portal.display_messages.profile_updated.success');
						this.userService.logAudit("updateProfile", 0).subscribe(data => { })
						this.modalRef = this.modalService.show(temppassword, {
							class: 'modal-sm', backdrop: true,
							ignoreBackdropClick: true
						});
						this.userService.populate();
					}
				}

			);

	}

	log() {
		this.modalRef.hide()
		this.userService.purgeAuth();
		this.router.navigateByUrl('/');
	}

	getmsgcount() {
		if (this.cid)
			this.userService.msgcountPP(this.cid)
				.subscribe(
					data => {
						this.CurrentUser.item.msgcount = data.UnReadTotalMsgCount
						this.userService.currentUserSubject.next(this.CurrentUser);
					})
	}

	// updateprofileshow(){
	// 	this.userService.currentUser.subscribe(
	// 		(userData) => {
	// 		  this.currentUser = userData;
	// 		}
	// 	  )
	// 	  this.userService.PUser.subscribe(
	// 		(userData) => {
	// 		  this.resp = userData;
	// 		}
	// 	  )  
	// }

	submitabout(tempabout) {
		this.imgprofile('isProfileDone');
		this.resabs = " ";
		// //////console.log(this.homedata);
		this.myobj.profileQuestions = "";
		this.myobj.profileQuestions = this.homedata;
		// //////console.log(this.homedata,this.myobj);
		if (this.myobj.profileQuestions[0].answer != "" && this.myobj.profileQuestions[1].answer != "" && this.myobj.profileQuestions[2].answer != "" && this.myobj.profileQuestions[3].answer != "" && this.myobj.profileQuestions[0].answer != "\n\n" && this.myobj.profileQuestions[1].answer != "\n\n" && this.myobj.profileQuestions[2].answer != "\n\n" && this.myobj.profileQuestions[3].answer != "\n\n") {
			//////console.log("innnnnn");
			this.userService.saveaboutme(this.myobj)
				.subscribe(
					data => {
						//////console.log(data);
						if (data.updateStatus == "true") {
							this.resab = this.userService.translateText('patient_portal.display_messages.about_us_updated.success');
							this.userService.logAudit("updateprofilequestions", 0).subscribe(data => { });
							this.modalRef = this.modalService.show(tempabout, { class: 'modal-sm' });

						} else {
							this.resabs = this.userService.translateText('hospital_portal.disp_messages.enter_valid_data.errormsg');

						}

					}
				);

		}
		else {
			this.resabs = this.userService.translateText('patient_portal.display_messages.enter_all_fields.error');
			//////console.log("Outtt");
		}
	}

	show: boolean;
	toggleShow(event, id, inputid) {
		this.show = !this.show;

		if (this.show) {
			$(`#${id}`).removeClass('fa-eye')
			$(`#${id}`).addClass('fa-eye-slash')
			let input = $(`#${inputid}`);
			input.attr('type', 'text')
		}
		else {
			$(`#${id}`).removeClass('fa-eye-slash')
			$(`#${id}`).addClass('fa-eye')
			let input = $(`#${inputid}`);
			input.attr('type', 'password')

		}
	}
	focus(event, id) {
		if (event) {
			$(`#${id}`).addClass('shown')
		}

	}
	outfocus(event, id) {
		if (event) {
			$(`#${id}`).removeClass('shown')
		}

	}
	changepwd(da, template: TemplateRef<any>) {
		this.resepon = "";
		//////console.log(da.value);
		this.patientservice.lastpass(this.CurrentUser.item.userAccountId, da.value.newPassword)
			.subscribe(
				data => {
					if (data.status != 'failure') {
						this.userService.chagepassword(da.value, this.CurrentUser.item.userAccountId)
							.subscribe(
								data => {
									//////console.log(data);
									if (data.item.status == "failure") {
										this.resepon = data.item.message;
										// this.modalRef = this.modalService.show(template);

									} else if (data.item.status == "success") {
										this.patientservice.pwdHistroy(this.CurrentUser.item.userAccountId, da.value.newPassword)
											.subscribe(data => { })
										this.userService.logAudit("chagepassword", 0).subscribe(data => { })
										this.res = data.item.message;
										this.modalRef = this.modalService.show(template, { class: 'modal-sm', backdrop: 'static' });
										da.resetForm();
										this.userService.populate();
										this.movable()
									} else {
										this.res = " ";

									}
								}
							);



					}
					else {
						this.resepon = data.message;
					}


				})
	}

	movable() {
		$(function () {
			let modalContent: any = $('.modal-content');
			let modalHeader = $('.modal-header');
			modalHeader.addClass('cursor-all-scroll');
			modalContent.draggable({
				handle: '.modal-header'
			});
		});
	}
	dateValueChange(event) {
		if (event.keyCode != 8) {
			if (event.target.value.length == 2 || event.target.value.length == 5) {
				var thisVal = event.target.value;
				thisVal += '/';
				event.target.value = thisVal;
			}
		}
	}

	showinvaild: boolean;
	checkempty(id) {
		////console.log(id)
		if (id == '' || id == null || id == 'Invalid Date') {
			this.showinvaild = true
		} else if (id != '' && id != null) {
			this.showinvaild = false
		}
	}
	start() {
		this.spantrue = true
	}
	clearFilter(i) {
		this.spantrue = true
		for (var l = 0; l < this.homedata.length; l++) {
			if (l = i) {
				this.checkabout[i] = true
			}
			else {
				this.checkabout[i] = false
			}
		}
	}

	onKey(event: any) {
		// var lowerCaseLetters = /[a-z]/g;
		// var upperCaseLetters = /[A-Z]/g;
		var numbers = /[0-9]/g;
		var alphabet = /[A-Z,a-z]/g;
		// var special = /[#$^+=!*()@%&]/g;
		// if (event.target.value.match(lowerCaseLetters)) {
		// 	this.passval = true
		// }
		// else {
		// 	this.passval = false
		// }
		if (event.target.value.match(alphabet)) {
			this.passval1 = true
		}
		else {
			this.passval1 = false
		}
		if (event.target.value.match(numbers)) {
			this.passval2 = true
		}
		else {
			this.passval2 = false
		}
		if (event.target.value.length >= 8) {
			this.passval3 = true
		}
		else {
			this.passval3 = false
		}
		// if (event.target.value.match(special)) {
		// 	this.passval4 = true
		// }
		// else {
		// 	this.passval4 = false
		// }

	}
	onKey1(event: any) {
		var lowerCaseLetters = /[a-z]/g;
		//var upperCaseLetters = /[A-Z]/g;
		var numbers = /[0-9]/g;
		var alphabet = /[A-Z,a-z]/g;
		var special = /[#$^+=!*()@%&]/g;
		if (event.target.value.match(lowerCaseLetters)) {
			this.passkey = true
		}
		else {
			this.passkey = false
		}
		if (event.target.value.match(lowerCaseLetters) && this.CurrentUser.item.officeStaff) {
			this.passkey1 = true
		}
		else if (event.target.value.match(alphabet) && !this.CurrentUser.item.officeStaff) {
			this.passkey1 = true
		}
		else {
			this.passkey1 = false
		}
		if (event.target.value.match(numbers)) {
			this.passkey2 = true
		}
		else {
			this.passkey2 = false
		}
		if (event.target.value.length >= 8) {
			this.passkey3 = true
		}
		else {
			this.passkey3 = false
		}
		if (event.target.value.match(special)) {
			this.passkey4 = true
		}
		else {
			this.passkey4 = false
		}


	}
	onKey2(event: any) {
		var lowerCaseLetters = /[a-z]/g;
		var upperCaseLetters = /[A-Z]/g;
		var numbers = /[0-9]/g;
		var alphabet = /[A-Z,a-z]/g;
		var special = /[#$^+=!*()@%&]/g;
		if (event.target.value.match(lowerCaseLetters)) {
			this.passlast = true
		}
		else {
			this.passlast = false
		}
		if (event.target.value.match(upperCaseLetters) && this.CurrentUser.item.officeStaff) {
			this.passlast1 = true
		}
		else if (event.target.value.match(alphabet) && !this.CurrentUser.item.officeStaff) {
			this.passlast1 = true
		}
		else {
			this.passlast1 = false
		}
		if (event.target.value.match(numbers)) {
			this.passlast2 = true
		}
		else {
			this.passlast2 = false
		}
		if (event.target.value.length >= 8) {
			this.passlast3 = true
		}
		else {
			this.passlast3 = false
		}
		if (event.target.value.match(special)) {
			this.passlast4 = true
		}
		else {
			this.passlast4 = false
		}
	}

	imgprofile(type) {

		this.patientid = window.localStorage['Puser'];
		this.userService
			.goback(this.patientid, type)
			.subscribe(
				data => {
					if (data) {
						this.userService.logAudit("disappearOnboardCard", 0).subscribe(data => { })
					}
				}
			);

	}



	checkphonelength(e, onchange) {
		if (!onchange) {
			return '';
		}
		this.Patpro.phone = "";
		let telecode = e.split(',')
		let codecoun = telecode[1]
		this.phonebycountrycode(codecoun, 'phone')
	}
	phonebycountrycode(codecoun, type) {
		this.userService.phonebycountrycode(codecoun)
			.subscribe(
				data => {
					if (type == 'other') {
						this.setlength1 = data.Length;
						this.maxlen1 = data.Length + this.CurrentUser.item.length;
						if (data.Length == 11) {
							this.setmask = this.CurrentUser.item.phoneFormat.split('#').join('0').concat('0')
						} else {
							this.setmask = this.CurrentUser.item.phoneFormat.split('#').join('0')
						}
					} else {
						this.setlength = data.Length;
						this.maxlen = data.Length + this.CurrentUser.item.length;
						if (data.Length == 11) {
							this.setmask = this.CurrentUser.item.phoneFormat.split('#').join('0').concat('0')
						} else {
							this.setmask = this.CurrentUser.item.phoneFormat.split('#').join('0')
						}
					}
				}
			);
	}
	checkphonelength1(e, onchange) {
		if (!onchange) {
			return '';
		}
		this.Patpro.phoneOther = "";
		let telecode = e.split(',')
		let codecoun = telecode[1]
		this.phonebycountrycode(codecoun, 'other')
	}


	checkphonlength(e) {
		let code = this.Patpro.code.split(',')
		let codeOther = this.Patpro.codeOther.split(',')
		if (code[0] + this.Patpro.phone == codeOther[0] + this.Patpro.phoneOther && this.Patpro.phoneOther) {
			this.toast.error(this.userService.translateText('patient_portal.display_messages.mobile_no_alter_no_should_not_same'), '', {
				timeOut: this.timealert
			})
			return this.Patpro.phone = ''
		} else {
			let telecode = e.split(',')
			let codecoun = telecode[1]
			this.phonebycountrycode(codecoun, 'phone')
		}
	}
	checkphonlength1(e) {
		let code = this.Patpro.code.split(',')
		let codeOther = this.Patpro.codeOther.split(',')
		if (code[0] + this.Patpro.phone == codeOther[0] + this.Patpro.phoneOther && this.Patpro.phone) {
			this.toast.error(this.userService.translateText('patient_portal.display_messages.mobile_no_alter_no_should_not_same'), '', {
				timeOut: this.timealert
			})
			return this.Patpro.phoneOther = ''
		} else {
			let telecode = e.split(',')
			let codecoun = telecode[1]
			this.phonebycountrycode(codecoun, 'other')
		}
	}

	getphone(userdetails) {
		let self = this;
		//check phone number is already exists    
		let code = this.Patpro.code.split(',')
		if (self.Patpro.phone && this.temcode + this.temPhone != code[0] + this.Patpro.phone) {

			let code = self.Patpro.code.split(',')
			let tempcode = self.tempCode.split(',')
			let phone = code[0] + '-' + self.Patpro.phone
			let temPhone = ''
			if (this.temPhone) {
				temPhone = tempcode[0] + '-' + this.temPhone
			}
			let data = {
				"oldEmail": '',
				"newEmail": '',
				"oldPhone": temPhone,
				"newPhone": code[0] + '-' + this.Patpro.phone,
				"addOrEdit": "edit",
				"updatingProfileRole": this.CurrentUser.item.userGroupId
			}
			this.patientservice.getUserExist(data, this.CurrentUser.item.userAccountKey).subscribe(
				data => {
					if (data.status == 'success') {
						if (data.popUpStatus) {
							this.userService.getuserdetails(phone)
								.subscribe(
									data => {
										if (data.firstName) {
											this.userinfo = data
											if (((!this.Patpro.firstName && !this.Patpro.lastName && !this.Patpro.email) || (data.firstName != this.Patpro.firstName) || (data.lastName != this.Patpro.lastName) || (data.email != this.Patpro.email))) {
												// if (self.Patpro.email) {
												// 	self.Patpro.comType = "EMAIL"
												// 	self.required = false
												// }
												// else{
												self.Patpro.comType = "NONE"
												// }
												this.modalRef1 = this.modalService.show(userdetails, {
													class: 'modal-md',
													backdrop: 'static'
												})
												this.movable();
											}
										}
									})
						}
					} else {
						self.Patpro.phone = "";
						if (self.Patpro.email) {
							self.Patpro.comType = "EMAIL"
							self.required = false
						}
						else {
							self.Patpro.comType = "NONE"
						}


						this.toast.error(this.userService.translateText('patient_portal.validations.mobile_no_already_exist.error_label'), '', {
							timeOut: this.timealert
						})
					}


				})

		}
		// end 
		if (this.temPhone == this.Patpro.phone) {
			return;
		} else {
			if (self.Patpro.email && self.Patpro.phone) {
				self.Patpro.comType = "BOTH"
				self.required = true
			}
			else if (!self.Patpro.email && !self.Patpro.phone) {
				self.Patpro.comType = "NONE"
				//self.required = false
			}
			else if (!self.Patpro.email) {
				self.Patpro.comType = "TEXT"
				self.required = false
			}
			else if (!self.Patpro.phone) {
				self.Patpro.comType = "EMAIL"
				self.required = true
			} else {
				self.Patpro.comType = "NONE"
			}
		}
	}
	changeFormatToDate(dateString) {
		var changedFormat;
		if (this.CurrentUser.item.language == 'en_uk' && (typeof dateString == 'string' || dateString instanceof String)) {
			var splitDate1 = dateString.split('/');
			if (splitDate1.length > 1) {
				var day1 = splitDate1[0];
				var month1 = splitDate1[1];
				var year1 = splitDate1[2];
				changedFormat = month1 + "/" + day1 + "/" + year1;
				return new Date(changedFormat)
			} else {
				var date: any = dateString
				return new Date(date)
			}
		} else {
			return new Date(dateString)
		}
	}

	saveSecQuestion() {
		this.showloader = true;
		const obj = {
			secQuestionOne: this.secQuestionOne,
			secQuestionThree: this.secQuestionThree,
			secQuestionTwo: this.secQuestionTwo,
			secQusAnswerOne: this.secQusAnswerOne,
			secQusAnswerThree: this.secQusAnswerThree,
			secQusAnswerTwo: this.secQusAnswerTwo
		}

		this.userService.saveSecQuesAns(this.CurrentUser.item.userAccountId, obj)
			.subscribe(data => {
				this.showloader = false;
				if (data.status == "Success") {

					this.userService.logAudit("saveSecQuesAns", 0).subscribe(data => { })
					this.toast.success(this.userService.translateText('patient_portal.display_messages.question_saved.success'), '', {
						timeOut: this.timealert
					})
				}
				else {
					this.toast.error(this.userService.translateText('patient_portal.display_messages.invalid_data.error'), '', {
						timeOut: this.timealert
					})
				}
			})
	}

	call() {
		alert(this.secQuestionOne)
	}


	getSecretQue() {
		this.userService.getSecQuesAns(this.CurrentUser.item.userAccountId)
			.subscribe(data => {
				if (data.secQuestionIdOne) {
					this.secQuestionOne = data.secQuestionIdOne
					this.secQuestionTwo = data.secQuestionIdTwo
					this.secQuestionThree = data.secQuestionIdThree
					this.secQusAnswerOne = data.secQusAnswerOne
					this.secQusAnswerTwo = data.secQusAnswerTwo
					this.secQusAnswerThree = data.secQusAnswerThree


					// //console.log("Edit Ques",data)
					this.changeques(this.secQuestionOne, 0);
				}
			})
	}
	changeques(eve, qus) {
		if (qus == 0) {
			this.secQuestionOne = eve;
		}
		if (qus == 1) {
			this.secQuestionOne = eve;
			this.secQusAnswerOne = '';
		} else if (qus == 2) {
			this.secQuestionTwo = eve;
			this.secQusAnswerTwo = '';
		} else if (qus == 3) {
			this.secQuestionThree = eve;
			this.secQusAnswerThree = '';
		}
		const d1 = _.reject(this.question, (o: any): any => { return o.userSecQuestionsId == this.secQuestionOne })
		this.selectques2 = _.reject(d1, (o: any): any => { return o.userSecQuestionsId == this.secQuestionTwo })
		this.selectques1 = _.reject(d1, (o: any): any => { return o.userSecQuestionsId == this.secQuestionThree })
		const ss = _.reject(this.question, (o: any): any => { return o.userSecQuestionsId == this.secQuestionThree })
		this.selectques = _.reject(ss, (o: any): any => { return o.userSecQuestionsId == this.secQuestionTwo })
	}


	phoneOthervalue: any = false
	viewalterno(phoneOthervalue) {
		if (!phoneOthervalue) {
			this.phoneOthervalue = true
			this.Patpro.otherPhoneType = 1
			this.changeAlterNo()
		}
	}
	changeAlterNo() {
		if (this.CurrentUser.item.language != 'en_uk') {
			this.Patpro.codeOther = '+1,USA'
		} else if (this.CurrentUser.item.language == 'en_uk') {
			this.Patpro.codeOther = '+44,UK'
		}
		if (this.CurrentUser.item.clientTeleCode) {
			this.Patpro.codeOther = this.CurrentUser.item.clientTeleCode + ',' + this.CurrentUser.item.clientCountryCode
		}
		this.Patpro.phoneOther = ''
	}
	userinfo: any;
	yesToShowUser(status) {
		if (status) {
			this.modalRef1.hide();
			this.Patpro.dob = new Date(this.userinfo.DOB);
			if (this.userinfo.imagePath && this.userinfo.imagePath.search("default_") == -1) {
				if (this.CurrentUser.item) {
					if (this.CurrentUser.item.hostModel == "CLOUD")
						this.imageURL = environment.cloudeImageURL;
					else
						this.imageURL = environment.vmImageURL;
				}
				this.patientUrl = this.imageURL + this.userinfo.imagePath;
			}
			this.Patpro.code = this.CurrentUser.item.clientTeleCode + ',' + this.CurrentUser.item.clientCountryCode
			this.Patpro.codeOther = this.CurrentUser.item.clientTeleCode + ',' + this.CurrentUser.item.clientCountryCode
			if (this.userinfo.teleCode)
				this.Patpro.code = this.userinfo.teleCode + ',' + this.userinfo.teleCountryCode;
			if (this.userinfo.teleCodeOther)
				this.Patpro.codeOther = this.userinfo.teleCodeOther + ',' + this.userinfo.teleCountryCodeOther;
			this.Patpro.firstName = this.userinfo.firstName
			this.Patpro.lastName = this.userinfo.lastName
			this.Patpro.userTitle = this.userinfo.userTile
			this.Patpro.email = this.userinfo.email ? this.userinfo.email : ''
			this.temMail = this.userinfo.email ? this.userinfo.email : ''
			this.Patpro.phone = this.userinfo.phone ? this.userinfo.phone : ''
			this.temPhone = this.userinfo.phone ? this.userinfo.phone : ''
			if (this.userinfo.comType == 'SMS') { this.userinfo.comType = 'TEXT' }
			this.Patpro.comType = this.userinfo.comType ? this.userinfo.comType : ''
			this.Patpro.phoneOther = this.userinfo.phoneOther ? this.userinfo.phoneOther : ''
			this.Patpro.otherPhoneType = this.userinfo.otherPhoneType ? this.userinfo.otherPhoneType : 1
			this.tempCode = this.Patpro.code
		} else {
			this.modalRef1.hide();
			this.Patpro.email = ''
			this.Patpro.phone = ''
			this.Patpro.code = this.CurrentUser.item.clientTeleCode + ',' + this.CurrentUser.item.clientCountryCode
		}
	}

}